module.exports = __webpack_public_path__ + "cw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/cw.svg
// module id = 508
// module chunks = 0